document.addEventListener("DOMContentLoaded", function () {
  // Event listener for successful form submission
  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      event.target.classList.add("modal-success");
      event.target.classList.remove("modal-error");
    },
    false
  );

  // Event listener for form validation error
  document.addEventListener(
    "wpcf7invalid",
    function (event) {
      event.target.classList.add("modal-error");
      event.target.classList.remove("modal-success");
    },
    false
  );

  // Event listener for form submission failure
  document.addEventListener(
    "wpcf7mailfailed",
    function (event) {
      event.target.classList.add("modal-error");
      event.target.classList.remove("modal-success");
    },
    false
  );

  // Get all buttons that open modals
  let open_modal_btns = document.querySelectorAll(".k-modal-btn");
  // Get all buttons that close modals
  let close_modal_btns = document.querySelectorAll(".k-modal-close");
  // Get all modal elements
  let modals = document.querySelectorAll(".modal");

  let previousActiveElement = null;

  // Function to hide all focusable elements outside the modal
  function hideNonModalFocusableElements() {
    previousActiveElement = document.activeElement;
    document
      .querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
      .forEach((element) => {
        if (!document.querySelector(".modal.show-modal").contains(element)) {
          element.setAttribute("tabindex", "-1");
        }
      });
  }

  // Function to restore original tabindex for focusable elements outside the modal
  function restoreTabIndexes() {
    document
      .querySelectorAll(
        'button, [href], input, select, textarea, [tabindex="-1"]'
      )
      .forEach((element) => {
        element.removeAttribute("tabindex");
      });
      if (previousActiveElement && previousActiveElement.focus) {
        previousActiveElement.focus();
      }
  }

  // Add event listener to open modal buttons
  for (let btn of open_modal_btns) {
    btn.addEventListener("click", () => {
      let dataType = btn.getAttribute("data-type");

      for (let modal of modals) {
        if (
          modal
            .querySelector(".k-modal")
            .classList.contains(`k-modal-${dataType}`)
        ) {
          modal.classList.add("show-modal");
          hideNonModalFocusableElements();
          // Update modal title if it's the apply-form modal
          if (dataType === "apply_form") {
            let jobPostTitle = document
              .getElementById("jobPostTitle")
              .getAttribute("data-title");
            let applyModalTitle = modal.querySelector(".k-modal-title");
            applyModalTitle.textContent = jobPostTitle;
          }
        }
      }
    });
  }

  // Function to close all modals
  function closeModal() {
    restoreTabIndexes();
    for (let modal of modals) {
      modal.classList.remove("show-modal");
    }
  }

  // Add event listener to close modal buttons
  for (let btn of close_modal_btns) {
    btn.addEventListener("click", closeModal);
  }

  // Close modal when clicking outside of it
  document.addEventListener("click", function (event) {
    for (let modal of modals) {
      if (event.target === modal) {
        closeModal();
      }
    }
  });

  // Close modal when pressing the Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  // Insert Job Titile in Hidden field
  var jobPostTitleElement = document.getElementById("jobPostTitle");
  if (jobPostTitleElement) {
    var jobTitle = jobPostTitleElement.getAttribute("data-title");
    if (jobTitle) {
      var hiddenJobTitleField = document.getElementById("job-title");
      if (hiddenJobTitleField) {
        hiddenJobTitleField.value = jobTitle;
      }
    }
  }
});
